<template>
  <div class="wrapper">
    <div class="btn-area">
      <button v-on:click="openModal">
        <picture>
          <source
            media="(min-width: 768px)"
            srcset="static/assets/images/btn_quiz_pc.png 1x, static/assets/images/btn_quiz_pc@2x.png 2x"
          >
          <source
            media="(min-width: 320px)"
            srcset="static/assets/images/btn_quiz_sp.png 1x, static/assets/images/btn_quiz_sp@2x.png 2x"
          >
          <img src="static/assets/images/btn_quiz_pc.png"
               alt="トリさんが出題する！とり野菜みそQ&amp;Aクイズ。全問正解で「東村アキコ先生書き下ろし限定壁紙」をプレゼント！">
        </picture>
      </button>

      <banner></banner>
    </div>

    <modal name="toriyasaiQuiz"
           :minWidth="300"
           :width="852"
           :height="655"
           :adaptive="true"
           @before-close="quizReset">

      <section v-if="state === 'start'">
        <div class="start-content">
          <header>
            <h2><img src="../assets/images/logo.svg" alt="株式会社まつや"></h2>
          </header>

          <p class="txt-start">とり野菜みその素朴なギモン！<br>全部で5問の<img src="../assets/images/btn_yes.svg" alt="◯"><img src="../assets/images/btn_no.svg" alt="×">クイズに<br class="hidden-sm">挑戦すると<br class="visible-sm">あなたの<br class="hidden-sm">みそ鍋革命度数がわかる！</p>

          <div class="btn-start">
            <button @click="state = 'q1'"><img src="../assets/images/btn_start.svg" alt="START"></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section v-else-if="state === 'q1'" class="question">
        <div class="quiz-content">
          <header>
            <p><img src="../assets/images/txt_q1.svg" alt="Q1"></p>
            <h2>とり野菜みその「とり」は<br>鶏肉の「とり」である。</h2>
          </header>

          <div class="illust-q1"><img src="../assets/images/img_q1.svg" alt=""></div>

          <ul>
            <li><button @click="state = 'q1-result'"><img src="../assets/images/btn_yes.svg" alt="◯"></button></li>
            <li><button @click="resultCount += 20, resultRight = true, state = 'q1-result'"><img src="../assets/images/btn_no.svg" alt="×"></button></li>
          </ul>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section class="result" v-else-if="state === 'q1-result'">
        <div class="quiz-result" v-bind:class="{ 'result-right': resultRight }">
          <header>
            <p><img src="../assets/images/txt_q1.svg" alt="Q1"></p>
            <h2 v-if="resultRight"><img src="../assets/images/hd_result_right.svg" alt="ピンポーンッ"></h2>
            <h2 v-else><img src="../assets/images/hd_result_wrong.svg" alt="ハズレーッ"></h2>
          </header>

          <p class="txt-catch">とり野菜みその「とり」は<br>野菜や栄養を「摂る」の「とり」。</p>
          <p class="txt-normal">「とり野菜みそ」は、江戸時代に廻船問屋を営んでいたまつや初代当主が船員たちの体調を考え、考案した味噌がルーツ。厳しい航海を乗り切るために不足しがちな野菜や栄養もたっぷり摂れ、船員たちに大変喜ばれていました。摂る「野菜味噌」→摂り「野菜味噌」→「とり野菜みそ」ということで、商品名の「とり」は鶏肉からではなく、野菜や栄養を摂るという意味からきています。</p>

          <div class="btn-next">
            <button @click="state = 'q2', resultRight = false"><img src="../assets/images/btn_quiz_next.svg" alt="次へ"></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section v-else-if="state === 'q2'" class="question">
        <div class="quiz-content">
          <header>
            <p><img src="../assets/images/txt_q2.svg" alt="Q2"></p>
            <h2>みそを入れるタイミングは<br>水だけの状態の時に入れる。</h2>
          </header>

          <div class="illust-q2">
            <img srcset="static/assets/images/img_q2.png, static/assets/images/img_q2@2x.png 2x"
                 src="static/assets/images/img_q2.png" alt="">
          </div>

          <ul>
            <li><button @click="resultCount += 20, resultRight = true, state = 'q2-result'"><img src="../assets/images/btn_yes.svg" alt="◯"></button></li>
            <li><button @click="state = 'q2-result'"><img src="../assets/images/btn_no.svg" alt="×"></button></li>
          </ul>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section class="result" v-else-if="state === 'q2-result'">
        <div class="quiz-result" v-bind:class="{ 'result-right': resultRight }">
          <header>
            <p><img src="../assets/images/txt_q2.svg" alt="Q2"></p>
            <h2 v-if="resultRight"><img src="../assets/images/hd_result_right.svg" alt="ピンポーンッ"></h2>
            <h2 v-else><img src="../assets/images/hd_result_wrong.svg" alt="ハズレーッ"></h2>
          </header>
          <p class="txt-catch">とり野菜みそって<br>調理がとってもカンタン！</p>
          <p class="txt-normal">一見、調理の手間がかかりそうに見えるとり野菜みそ。いえいえ、実はとーってもカンタンなんです。<br>まずは、お鍋に水をいれて、次にとり野菜みそを投入。かき混ぜて溶かしたら、具材を入れて火にかければ、<br>ハイッ！完成〜！！</p>

          <div class="btn-next">
            <button @click="state = 'q3', resultRight = false"><img src="../assets/images/btn_quiz_next.svg" alt="次へ"></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section v-else-if="state === 'q3'" class="question">
        <div class="quiz-content">
          <header>
            <p><img src="../assets/images/txt_q3.svg" alt="Q3"></p>
            <h2>とり野菜みそは<br>一人鍋もできる。</h2>
          </header>

          <div class="illust-q3">
            <img srcset="static/assets/images/img_q3.png, static/assets/images/img_q3@2x.png 2x"
                 src="static/assets/images/img_q3.png" alt="">
          </div>

          <ul>
            <li><button @click="resultCount += 20, resultRight = true, state = 'q3-result'"><img src="../assets/images/btn_yes.svg" alt="◯"></button></li>
            <li><button @click="state = 'q3-result'"><img src="../assets/images/btn_no.svg" alt="×"></button></li>
          </ul>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section class="result" v-else-if="state === 'q3-result'">
        <div class="quiz-result" v-bind:class="{ 'result-right': resultRight }">
          <header>
            <p><img src="../assets/images/txt_q3.svg" alt="Q3"></p>
            <h2 v-if="resultRight"><img src="../assets/images/hd_result_right.svg" alt="ピンポーンッ"></h2>
            <h2 v-else><img src="../assets/images/hd_result_wrong.svg" alt="ハズレーッ"></h2>
          </header>

          <div class="illust-q3-result">
            <img srcset="static/assets/images/img_q3_result.png, static/assets/images/img_q3_result@2x.png 2x"
                 src="static/assets/images/img_q3_result.png" alt="">
          </div>

          <p class="txt-catch">スパウトタイプがあるから<br>小分けに使用できる！</p>
          <p class="txt-normal">キャップ付だから、使い切らなくても保存がラク。少しずつ使えば、なんと一人鍋が10回※もできます！鍋だけじゃなく料理の調味料としてもいろんな使い道があるんです。<br><span class="note">※500gサイズのスパウトパックでの量です。。</span></p>

          <div class="btn-next">
            <button @click="state = 'q4', resultRight = false"><img src="../assets/images/btn_quiz_next.svg" alt="次へ"></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section v-else-if="state === 'q4'" class="question">
        <div class="quiz-content">
          <header>
            <p><img src="../assets/images/txt_q4.svg" alt="Q4"></p>
            <h2>とり野菜みそは<br>塩分が高めである。</h2>
          </header>

          <div class="illust-q4">
            <img srcset="static/assets/images/img_q4.png, static/assets/images/img_q4@2x.png 2x"
                 src="static/assets/images/img_q4.png" alt="">
          </div>

          <ul>
            <li><button @click="state = 'q4-result'"><img src="../assets/images/btn_yes.svg" alt="◯"></button></li>
            <li><button @click="resultCount += 20, resultRight = true, state = 'q4-result'"><img src="../assets/images/btn_no.svg" alt="×"></button></li>
          </ul>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section class="result" v-else-if="state === 'q4-result'">
        <div class="quiz-result" v-bind:class="{ 'result-right': resultRight }">
          <header>
            <p><img src="../assets/images/txt_q4.svg" alt="Q4"></p>
            <h2 v-if="resultRight"><img src="../assets/images/hd_result_right.svg" alt="ピンポーンッ"></h2>
            <h2 v-else><img src="../assets/images/hd_result_wrong.svg" alt="ハズレーッ"></h2>
          </header>

          <p class="txt-catch">野菜をたくさん入れるから<br>ちょうどいい味に仕上がる。</p>
          <p class="txt-normal">500ccのお水に対して200gの袋を全部入れます。こんなに入れて塩辛くないの？と思うかもしれませんが、水分を含んだ白菜をたくさん入れるので、ちょうどいい塩梅の味に仕上がります。</p>

          <div class="btn-next">
            <button @click="state = 'q5', resultRight = false"><img src="../assets/images/btn_quiz_next.svg" alt="次へ"></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section v-else-if="state === 'q5'" class="question">
        <div class="quiz-content">
          <header>
            <p><img src="../assets/images/txt_q5.svg" alt="Q5"></p>
            <h2>とり野菜みそって<br>他の鍋の素と比べたら<br>ちょっとお高め。</h2>
          </header>

          <div class="illust-q5">
            <img srcset="static/assets/images/img_miso.png, static/assets/images/img_miso@2x.png 2x"
                 src="static/assets/images/img_miso.png" alt="">
          </div>

          <ul>
            <li><button @click="state = 'q5-result'"><img src="../assets/images/btn_yes.svg" alt="◯"></button></li>
            <li><button @click="resultCount += 20, resultRight = true, state = 'q5-result'"><img src="../assets/images/btn_no.svg" alt="×"></button></li>
          </ul>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <section class="result" v-else-if="state === 'q5-result'">
        <div class="quiz-result" v-bind:class="{ 'result-right': resultRight }">
          <header>
            <p><img src="../assets/images/txt_q5.svg" alt="Q5"></p>
            <h2 v-if="resultRight"><img src="../assets/images/hd_result_right.svg" alt="ピンポーンッ"></h2>
            <h2 v-else><img src="../assets/images/hd_result_wrong.svg" alt="ハズレーッ"></h2>
          </header>

          <p class="txt-catch">この小さなサイズで<br>3〜4人前も作れるんです！</p>

          <div class="figure-wrap">
            <figure>
              <img srcset="static/assets/images/img_miso.png, static/assets/images/img_miso@2x.png 2x"
                   src="static/assets/images/img_miso.png" alt="">
              <figcaption>※200gサイズ</figcaption>
            </figure>
            <p class="txt-normal">他社製品と比べると、半分くらいのサイズで金額は同じくらい。ちょっと割高だな〜って感じる方もいるのでは？いえいえ、この小さなサイズでしっかり3〜4人前の立派なとり野菜みそ鍋ができるんです！</p>
          </div>

          <div class="btn-finish">
            <button @click="state = 'finish'">
              <img src="../assets/images/btn_quiz_result.svg" alt="結果発表">
            </button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </section>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 100">
        <div class="finish result-100">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="download-link">
            <button @click="wallPaperModal"><img src="../assets/images/btn_download.svg" alt=""></button>
          </div>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 80">
        <div class="finish result-80">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 60">
        <div class="finish result-60">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 40">
        <div class="finish result-40">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 20">
        <div class="finish result-20">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>

      <div class="finish-wrap" v-else-if="state === 'finish' && resultCount === 0">
        <div class="finish result-00">
          <a class="recipie-link" href="http://www.toriyasaimiso.jp/recipe" target="_blank"><img src="../assets/images/btn_result_recipie.svg" alt="とり野菜みそレシピへ"></a>

          <div class="btn-close">
            <button @click="closeModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>
    </modal>

    <modal name="wallPaper"
           :minWidth="300"
           :width="900"
           :height="700"
           :adaptive="true">
      <div class="wallpaper-wrap">
        <div class="wallpaper-inner">
          <wallpaper></wallpaper>

          <div class="btn-close-wallpaper">
            <button @click="closeWallPaperModal"><img src="../assets/images/btn_close.svg" alt=""></button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VModal from 'vue-js-modal'
  import Wallpaper from './Wallpaper'
  import Banner from './Banner'

  Vue.use(VModal)

  export default {
    name: 'Quiz',

    components: {
      Wallpaper,
      Banner
    },

    data () {
      return {
        state: 'start',
        resultRight: false,
        resultCount: 0
      }
    },

    methods: {
      openModal () {
        this.$modal.show('toriyasaiQuiz')
        this.quizReset()
      },

      closeModal () {
        this.$modal.hide('toriyasaiQuiz')
        this.quizReset()
      },

      quizReset () {
        this.state = 'start'
        this.resultRight = false
        this.resultCount = 0
      },

      wallPaperModal () {
        this.$modal.show('wallPaper')
      },

      closeWallPaperModal () {
        this.$modal.hide('wallPaper')
      }
    }
  }
</script>

<style lang="scss">
  .wrapper {
    .v--modal {
      background-color: transparent;
      box-shadow: none;
    }
  }
</style>

<style lang="scss" scoped>
  @import "../assets/scss/common";

  a {
    &:hover {
      opacity: .6;
      transition: opacity 200ms ease;
    }
  }

  .bnr {
    margin: 10px 2vw 0;
  }

  .hidden-sm {
    @include media(sm) {
      display: none;
    }
  }

  .visible-sm {
    display: none;

    @include media(sm) {
      display: block;
    }
  }

  .btn-area {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1vw 1vw 30px;

    @include media(sm) {
      padding: {
        top: 0;
        bottom: 40px;
      }
    }

    @include media(sm) {
      padding-bottom: 60px;
    }

    button {
      @include media(sm) {
        transform: translateX(10px);
      }

      @include media(md) {
        transform: translateX(117px);
      }

      &:hover {
        opacity: .6;
        transition: opacity 200ms ease;
      }
    }
  }

  section, .finish-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 100%;
    height: 100%;
  }

  %content {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    max-width: 320px;
    max-height: 410px;
    background: {
      position: 50% 50%;
      size: contain;
      repeat: no-repeat;
    }

    @include media(sm) {
      max-width: none;
      max-height: none;
    }
  }

  .start-content {
    @extend %content;
    background-image: url("../assets/images/bg_quiz_start@sp.svg");
    padding-top: 54px;

    @include media(sm) {
      padding-top: 13%;
      background-image: url("../assets/images/bg_quiz_start.svg");
    }

    header {
      text-align: center;

      h2 {
        width: 30vw;
      }
    }

    p {
      margin: 12% 0 5%;
      font: {
        size: 1.8rem;
        weight: 600;
      }
      line-height: 1.6;
      text-align: center;

      img {
        margin: 0 .07em;
        width: 1.2em;
        vertical-align: -.4rem;
      }

      @include media(sm) {
        margin: 5% 0;
        font-size: 3.0rem;
      }
    }

    .btn-start {
      width: 25vw;
      max-width: 189px;

      @include media(sm) {
        transform: translateX(58%);
      }
    }
  }

  .quiz-content {
    @extend %content;
    padding-top: 42px;
    background-image: url("../assets/images/bg_quiz_question@sp.svg");

    @include media(sm) {
      padding-top: 16%;
      background-image: url("../assets/images/bg_quiz_question.svg");
    }

    @include media(md) {
      padding-top: 11%;
    }

    header {
      text-align: center;

      p {
        img {
          width: 38px;

          @include media(sm) {
              width: 70px;
          }

          @include media(md) {
            width: auto;
          }
        }
      }

      h2 {
        padding: 1em 0;
        font: {
          size: 1.6rem;
          weight: 600;
        }
        line-height: 1.55;

        @include media(sm) {
          font-size: 2.5rem;
        }

        @include media(md) {
          font-size: 3.7rem;
        }
      }
    }

    ul {
      display: flex;
      justify-content: center;
    }

    li {
      width: 66px;
      margin: 0 2vw;

      @include media(sm) {
        width: 110px;
        margin: 0 15px;
      }
    }
  }

  .illust-q1 {
    position: absolute;
    right: 14%;
    bottom: 20%;
    width: 64px;

    @include media(sm) {
      width: 126px;
      bottom: 35%;
    }
  }

  .illust-q2 {
    position: absolute;
    right: 16%;
    bottom: 22%;
    width: 64px;

    @include media(sm) {
      width: auto;
      right: 6%;
      bottom: 33%;
    }

    @include media(md) {
      right: 11%;
    }
  }

  .illust-q3 {
    position: absolute;
    right: 19%;
    bottom: 25%;
    width: 64px;

    @include media(sm) {
      width: auto;
      right: 10%;
      bottom: 34%;
    }
  }

  .illust-q3-result {
    position: absolute;
    right: 41%;
    bottom: 27%;
    width: 64px;

    @include media(sm) {
      width: auto;
      right: 27%;
      bottom: 16%;
    }
  }

  .illust-q4 {
    position: absolute;
    right: 17%;
    bottom: 24%;
    width: 64px;

    @include media(sm) {
      width: auto;
      right: 11%;
      bottom: 34%;
    }
  }

  .illust-q5 {
    position: absolute;
    right: 21%;
    bottom: 19%;
    width: 50px;
    transform: rotate(23deg);

    @include media(sm) {
      width: 100px;
      right: 15%;
      bottom: 35%;
    }

    @include media(md) {
      width: auto;
      right: 16%;
      bottom: 30%;
    }
  }

  .quiz-result {
    @extend %content;
    padding-top: 42px;
    background-image: url("../assets/images/bg_result_wrong@sp.png");

    @include media(sm) {
      background-image: url("../assets/images/bg_result_wrong.png");
      padding-top: 12%;
    }

    @include media(md) {
      padding-top: 8%;
    }

    &.result-right {
      background-image: url("../assets/images/bg_result_right@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result_right.png");
      }

      header {
        h2 {
          width: 192px;

          @include media(sm) {
            width: 306px;
          }

          @include media(md) {
            width: auto;
          }
        }
      }
    }

    header {
      text-align: center;

      p {
        img {
          width: 38px;

          @include media(sm) {
              width: 70px;
          }

          @include media(md) {
            width: auto;
          }
        }
      }

      h2 {
        width: 176px;
        padding-top: 1rem;

        @include media(sm) {
          width: 280px;
        }

        @include media(md) {
          width: auto;
        }
      }
    }

    .txt-catch {
      padding: .3em 0;
      font: {
        size: 1.6rem;
        weight: 800;
      }
      line-height: 1.4;
      text-align: center;

      @include media(sm) {
        font-size: 3.0rem;
      }
    }

    .txt-normal {
      max-width: 26.2em;
      min-height: 12.1em;

      font: {
        size: .8rem;
        weight: 600;
      }
      line-height: 1.75;
      text-align: justify;

      .note {
        font-size: .75em;
      }

      @include media(sm) {
        font-size: 1.5rem;
        max-width: 23.4em;
      }
    }

    .btn-next {
      position: absolute;
      bottom: 75px;
      left: 50%;
      width: 64px;
      transform: translateX(-50%);

      @include media(sm) {
        width: 80px;
        bottom: 21%;
      }

      @include media(md) {
        width: auto;
        bottom: 15.6%;
      }
    }
  }

  .figure-wrap {
    display: flex;
    max-width: 370px;

    figure {
      margin-right: 8px;

      img {
        width: 43px;
        transform: rotate(-9deg);
      }

      figcaption {
        margin-top: 1rem;
        font-size: .7rem;
      }
    }

    .txt-normal {
      max-width: 14.2em;
    }

    @include media(sm) {
      max-width: 370px;

      figure {
        img {
          width: auto;
          transform: rotate(-9deg) translateX(-16px);
        }

        figcaption {
          margin-top: 1rem;
          font-size: 1.1rem;
        }
      }
    }

    @include media(md) {
      .txt-normal {
        max-width: 16.2em;
      }
    }
  }

  .btn-finish {
    position: absolute;
    left: 50%;
    bottom: 90px;
    width: 70px;
    transform: translateX(-50%);

    @include media(sm) {
      width: 117px;
      bottom: 133px;
    }

    @include media(md) {
      width: auto;
      bottom: 110px;
    }
  }

  .btn-close {
    position: absolute;
    right: 11%;
    top: 11%;
    width: 40px;
    max-width: 75px;

    @include media(sm) {
      width: auto;
      right: 21%;
      top: 7%;
    }
  }

  .wallpaper-wrap {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .wallpaper-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .btn-close-wallpaper {
    @extend .btn-close;
    right: .5%;
    top: .5%;
  }

  .finish {
    @extend %content;

    &.result-100 {
      background-image: url("../assets/images/bg_result100@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result100.png");
      }
    }

    &.result-80 {
      background-image: url("../assets/images/bg_result80@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result80.png");
      }
    }

    &.result-60 {
      background-image: url("../assets/images/bg_result60@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result60.png");
      }
    }

    &.result-40 {
      background-image: url("../assets/images/bg_result40@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result40.png");
      }
    }

    &.result-20 {
      background-image: url("../assets/images/bg_result20@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result20.png");
      }
    }

    &.result-00 {
      background-image: url("../assets/images/bg_result00@sp.png");

      @include media(sm) {
        background-image: url("../assets/images/bg_result00.png");
      }
    }
  }

  .recipie-link {
    display: block;
    text-align: center;
    padding-top: 22.5%;

    img {
      width: 128px;
    }

    @include media(sm) {
      padding-top: 16.5%;

      img {
        width: auto;
      }
    }

    @include media(md) {
      padding-top: 12.5%;
    }
  }

  .download-link {
    position: absolute;
    bottom: 36%;
    left: 50%;
    transform: translateX(-50%);

    img {
      width: 130px;
    }

    @include media(sm) {
      bottom: 27%;

      img {
        width: auto;
      }
    }

    @include media(md) {
      bottom: 23%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Quiz.vue?d1758ba0